import React, { useEffect, useState } from 'react';
import AppContext from './AppContext';
import { setItemToLocalStorage } from '../../common/Storage';
import { navigate } from 'gatsby';

const AppProvider = ({ children }: { children: any }) => {
  const availableChannels = {
    "mobile": true,
    "bam": true,
    "fiber": true
  };
  const [urlRedirect, setUrlRedirect] = useState('');
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      const transactionId = params.get('transactionId');
      const url_redirect = params.get('url_redirect');
      if (url_redirect) {
        setUrlRedirect(url_redirect);        
        setTimeout(() => {
          navigate('');
        }, 500);
      }
      if (transactionId) {
        setItemToLocalStorage('transactionId', 5, transactionId);
        setTimeout(() => {
          navigate('');
        }, 500);
      }
    }
  }, []);

  return (
    <AppContext.Provider value={{ availableChannels, urlRedirect, setUrlRedirect }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
